import { FC } from 'react';
import { Skeleton } from 'antd';
import CreatorProfileSkeleton from '@components/skeleton/creatorProfile/CreatorProfile';
import { useScreen } from '@shared/helpers/screen.helper';
import { Container, ContentContainer, VideoSkeleton, Wrapper } from './RecipeCover.style';
const RecipeCoverSkeleton: FC = () => {
  const {
    isMobile
  } = useScreen();
  const renderMobile = () => {
    return <>
                <VideoSkeleton active />
                <ContentContainer>
                    <CreatorProfileSkeleton />
                    <Skeleton paragraph={{
          rows: 7
        }} className="content-skeleton" active />
                </ContentContainer>
            </>;
  };
  return isMobile ? renderMobile() : <>
            <Container>
                <Wrapper>
                    <VideoSkeleton active />
                </Wrapper>
            </Container>
            <ContentContainer>
                <CreatorProfileSkeleton />
                <Skeleton paragraph={{
        rows: 2
      }} className="content-skeleton" active />
            </ContentContainer>
        </>;
};
export default RecipeCoverSkeleton;